import React from 'react';
import { Flex } from 'antd';

import SearchInput from 'components/SearchInput';

import { Container, HeaderContainer, Subtitle, Title, TextContainer } from './Header.styles';

interface HeaderProps {
  handleSearchChange: (value: string) => void;
  searchInputRef: React.RefObject<any>;
}

const Header: React.FC<HeaderProps> = ({ handleSearchChange, searchInputRef }: HeaderProps) => (
  <Container>
    <HeaderContainer>
      <TextContainer>
        <Title>My Enrolled Courses</Title>
        <Subtitle>View and manage all your courses in one place.</Subtitle>
      </TextContainer>

      <Flex gap='1rem' justify='space-between'>
        <SearchInput
          autoFocus
          small
          placeholder='Search'
          initValue=''
          onSearch={handleSearchChange}
          allowEmptySearch
          aria-label='Search for a course by Name, Instance, Course Code, Section Code, or Term.'
          ref={searchInputRef}
          maxLength={100}
        />
      </Flex>
    </HeaderContainer>
  </Container>
);

export default Header;
